import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { makeTransformStyles } from '../../core/styles';
import capitalize from 'lodash/capitalize';
import { MAP_BREAKPOINT } from './variables';
import Link from '@material-ui/core/Link';

const Place = withStyles((theme) => ({
  root: {
    position: 'relative',
    zIndex: 30,
  },
  name: {
    color: theme.props.palette.secondary.main,
    marginBottom: theme.spacing(1),
    fontWeight: 'bold',
  },
  box: {
    border: `1px solid ${theme.props.palette.secondary.main}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(1),
    textAlign: 'center',
    width: '100%',
    position: 'relative',
    display: 'block',
    zIndex: 20,
    [theme.breakpoints.up(MAP_BREAKPOINT)]: {
      width: 170,
    },
  },
  img: {
    width: '100%',
    maxWidth: 90,
    height: 'auto',
  },
  arrow: {
    color: theme.props.palette.secondary.main,
    position: 'absolute',
    right: theme.spacing(1),
    top: '50%',
    ...makeTransformStyles('translateY(-50%)'),
    [theme.breakpoints.up(MAP_BREAKPOINT)]: {
      display: 'none',
    },
  },
  line: (props) => {
    const { top, right, bottom, left, width, height, border = [] } = props;
    return {
      position: 'absolute',
      zIndex: 10,
      display: 'none',
      [theme.breakpoints.up(MAP_BREAKPOINT)]: { display: 'block' },
      top,
      right,
      bottom,
      left,
      width,
      height,
      ...Object.assign(
        {},
        ...['top', 'right', 'bottom', 'left']
          .filter((d) => border.includes(d))
          .map((d) => ({
            [`border${capitalize(
              d,
            )}`]: `1px solid ${theme.props.palette.secondary.main}`,
          })),
      ),
    };
  },
}))(({ classes, link, value, src }) => (
  <div className={classes.root}>
    <Typography className={classes.name}>{value}</Typography>
    <Link href={link} target="_blank" rel="noopener" className={classes.box}>
      <img src={src} className={classes.img} />
      <KeyboardArrowDownIcon className={classes.arrow} fontSize="large" />
    </Link>
    <div className={classes.line} />
  </div>
));

export default Place;
